<template>
  <section>
    <div class="columns">
      <div class="column">
        <div class="container mt-3">
          <div class="box">
            <section class="hero is-primary welcome is-small mb-4">
              <div class="hero-body">
                <div class="container">
                  <h1 class="title">
                    Dashboard Proceso {{ year
                    }}<i class="fas fa-chart-pie ml-2"></i>
                  </h1>
                </div>
              </div>
            </section>
            <template>
              <div class="columns">
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'ACEPTADA'}"
                      @click="aplicarFiltro('ACEPTADA')"
                  >
                    <header class="card-header has-background-primary">
                      <p class="card-header-title has-text-white">Aceptadas</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[0] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'EMITIDA'}"
                      @click="aplicarFiltro('EMITIDA')"
                  >
                    <header class="card-header has-background-success">
                      <p class="card-header-title has-text-white">Emitidas</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[1] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'DEVUELTA'}"
                      @click="aplicarFiltro('DEVUELTA')"
                  >
                    <header class="card-header has-background-warning">
                      <p class="card-header-title has-text-white">Devueltas</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[2] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'EN CURSO'}"
                      @click="aplicarFiltro('EN CURSO')"
                  >
                    <header class="card-header has-background-info">
                      <p class="card-header-title has-text-white">En curso</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[3] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                  >
                    <header class="card-header has-background-danger">
                      <p class="card-header-title has-text-white">Sin iniciar</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[4] }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template>
              <div class="columns">
                <div class="column is-7">
                  <div class="card card-stretch">
                    <header class="card-header is-justify-content-space-between is-align-items-center">
                      <p class="card-header-title">Promedio de horas por área</p>
                      <div class="buttons">
                        <b-button type="is-success" icon-right="" @click="openModalPromHours">
                          Ver datos
                        </b-button>
                        <b-button type="is-info" icon-right="file-excel" @click="downloadData(`/performances/summary_hours_performance/${year}.xlsx`)">
                          Exportar Datos
                        </b-button>
                      </div>
                    </header>
                    <div class="card-content">
                      <apexchart ref="apexChartComponent" type="bar" :options="options_bar" :series="series_bar"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="column is-5">
                  <div class="card card-stretch">
                    <header class="card-header is-justify-content-space-between is-align-items-center">
                      <p class="card-header-title">Estados de las solicitudes</p>
                      <div class="buttons">
                        <b-button type="is-success" icon-right="" @click="showModalState = true">
                          Ver datos
                        </b-button>
                        <b-button type="is-info" icon-right="file-excel" @click="downloadData(`/performances/summary_state_performances/${year}.xlsx`)">
                          Exportar a Datos
                        </b-button>
                      </div>
                    </header>
                    <div class="card-content">
                      <apexchart type="pie" :options="options_pie" :series="series_pie"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="card card-stretch">
                    <header class="card-header is-justify-content-space-between is-align-items-center">
                      <p class="card-header-title">Promedio Horas Semanales por Académico</p>
                      <div class="buttons">
                        <b-button type="is-success" icon-right="" @click="openModalPromHours">
                          Ver datos
                        </b-button>
                        <b-button type="is-info" icon-right="file-excel" @click="downloadData(`/performances/summary_hours_performance/${year}.xlsx`)">
                          Exportar a Datos
                        </b-button>
                      </div>
                    </header>
                    <div class="card-content">
                      <apexchart ref="apexChartComponentAcademic" type="bar" :options="option_new_academic_hours" :series="series_new_academic_hours"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <b-loading
        :is-full-page="true"
        v-model="isLoading"
        :can-cancel="false"
    ></b-loading>
    <b-modal v-model="showModalPromHours"
             has-modal-card
             trap-focus
             :destroy-on-hide="true"
             aria-role="dialog"
             aria-modal
             width= "75%"
    >
      <template>
        <div class="modal-card" style="width: 100%; max-width: 100%;">
          <header class="modal-card-head">
            <p class="modal-card-title">Promedio de horas por área</p>
            <button type="button" class="delete" @click="closeModalPromHours" />
          </header>

          <section class="modal-card-body">
            <b-table :per-page="10"
                     paginated
                     :data="data_prom_hours" :columns="columns_prom_hours"></b-table>
          </section>

          <footer class="modal-card-foot actions">
            <div class="actions">
              <button class="button" type="button" @click="closeModalPromHours">
                Aceptar
              </button>
            </div>
          </footer>
        </div>

      </template>

    </b-modal>

    <b-modal v-model="showModalState"
             has-modal-card
             trap-focus
             :destroy-on-hide="true"
             aria-role="dialog"
             aria-modal
             width= "75%"
    >
      <template>
        <div class="modal-card" style="width: 100%; max-width: 100%;">
          <header class="modal-card-head">
            <p class="modal-card-title">Estado de las solicitudes</p>
            <button type="button" class="delete" @click="showModalState = false" />
          </header>

          <section class="modal-card-body">
            <b-table :per-page="10"
                     paginated
                     :data="data_perf_states" :columns="columns_perf_states"></b-table>
          </section>

          <footer class="modal-card-foot actions">
            <div class="actions">
              <button class="button" type="button" @click="showModalState = false">
                Aceptar
              </button>
            </div>
          </footer>
        </div>

      </template>

    </b-modal>

  </section>
</template>

<script>

import axios from "axios";

export default {
  props: ["unit", "year", "is_principal"],
  data() {
    return {
      isLoading: false,
      showModalPromHours: false,
      showModalState: false,
      chartReady: false,
      filtroActivo: null,
      options_bar: {
        plotOptions: {
          bar: {
            distributed: true // importante para aplicar colores por barra
          }
        },
        chart: {
          id: 'basic-bar',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: ["Docencia", "Investigación y Desarrollo", "Asistencia Técnica", "Perfeccionamiento", "Administración Académica", "Extensión", "Educación Continua"]
        },
        colors: ['#00e396', '#008ffb', '#775dd0', '#ff4560', '#feb019', '#ff7675', '#6993ff'],
        legend: {
          show: false
        },
      },
      series_bar: [
        {
          name: 'Horas Promedio',
          data: [0, 0, 0, 0, 0, 0, 0]
        }
      ],
      options_pie: {
        labels: ['Aceptadas', 'Emitidas', 'Devueltas', 'En curso', 'Sin iniciar'],
        colors: ['#00d1b2', '#48c78e', '#ffe08a', '#167df0', '#f14668'],
        legend: {
          position: 'bottom'
        },
      },
      series_pie: [0, 0, 0, 0, 0],
      options_academic_hours: {
        chart: {
          id: "academic-bar",
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 5,
          curve: 'smooth'
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '8px', // Ajusta el tamaño de la fuente
            },
            rotate: -55,
          },

        },
        yaxis: {
          min: 20 // Configura el valor mínimo del eje Y a 0
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            gradientToColors: [ '#FDD835'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          },
        }
       // Un color uniforme para todas las barras

      },
      series_academic_hours: [
        {
          name: "Horas Promedio",
          data: [] // Se llenará dinámicamente con los promedios
        }
      ],
      option_new_academic_hours: {
        plotOptions: {
          bar: {
            distributed: true // importante para aplicar colores por barra
          }
        },
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          }
        },

        yaxis: {
          labels: {
            style: {
              fontSize: '12px'
            },
            maxWidth: 250,
            offsetX: -10
          }
        },

        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                formatter: function(val) {
                  // Formatear el valor para mostrar solo un decimal
                  return val.toFixed(1);
                }
              }
            }
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '8px', // Ajusta el tamaño de la fuente
            },
            rotate: -55,
          },
        },
        colors: ['#00e396', '#008ffb', '#775dd0', '#ff4560', '#feb019', '#ff7675', '#6993ff'],
        legend: {
          position: 'top',
        },
      },
      series_new_academic_hours: [],
      academic_performance_state: null,
      academic_average_hours: null,
      averate_total_hours: null,
      prom_total_eq_sem: [0, 0, 0, 0, 0, 0, 0],
      indicator_state: [0, 0, 0, 0, 0],
      data_prom_hours: [],
      columns_prom_hours: [
        {
          field: "academic_name",
          label: "Académico",
        },
        {
          field: "hours_docencia",
          label: "Docencia",
        },
        {
          field: "hours_inv_y_des",
          label: "Investigación y Desarrollo",
        },
        {
          field: "hours_asi_tec",
          label: "Asistencia técnica",
        },
        {
          field: "hours_perf",
          label: "Perfeccionamiento",
        },
        {
          field: "hours_admin",
          label: "Administración",
        },
        {
          field: "hours_extencion",
          label: "Extensión",
        },
        {
          field: "hours_educ",
          label: "Educación Continua",
        },
        {
          field: "hours_semanales_eq",
          label: "Total Horas"
        }
      ],
      data_perf_states:[],
      columns_perf_states: [
        {
          field: "academic_name",
          label: "Académico"
        },
        {
          field: "email",
          label: "Correo"
        },
        {
          field: "unit_name",
          label: "Unidad"
        },
        {
          field: "state",
          label: "Estado"
        },
        {
          field: "send_date",
          label: "Fecha envío"
        },
        {
          field: "accept_date",
          label: "Fecha aceptación"
        }
      ]
    };
  },
  created() {
    this.dashboardData()
  },
  methods: {
    dashboardData(){
      this.isLoading = true;
      axios
          .get(`/performances/dashboard-data/${this.year}.json`)
          .then((res) => {
            this.prom_total_eq_sem = res.data["prom_total_eq_sem"]
            this.data_perf_states =  res.data["academic_performance_state"]
            this.$refs.apexChartComponent.updateSeries([
              {
                name: "Horas Promedio",
                data: this.prom_total_eq_sem
              }
            ]);
            //this.series_bar[0].data = this.prom_total_eq_sem;

            this.series_pie = res.data["indicator_state"];
            this.indicator_state = res.data["indicator_state"];
            this.academic_average_hours = res.data["academic_average_hours"];
            this.data_prom_hours = res.data["academic_average_hours_equiv"];
            if (this.data_prom_hours) {
              let name_academics = this.data_prom_hours.map((item) => item.academic_name)
              //this.options_academic_hours.xaxis.categories =name_academics
              this.$refs.apexChartComponentAcademic.updateOptions({
                xaxis: {
                  categories: name_academics // Actualiza los nombres del eje x
                }
              })
              this.$refs.apexChartComponentAcademic.updateSeries([
                {
                  name: "Docencia",
                  data: this.data_prom_hours.map(item => item.hours_docencia)
                },
                {
                  name: "Investigación y Desarrollo",
                  data: this.data_prom_hours.map(item => item.hours_inv_y_des)
                },
                {
                  name: "Asistencia Técnica",
                  data: this.data_prom_hours.map(item => item.hours_asi_tec)
                },
                {
                  name: "Perfeccionamiento",
                  data: this.data_prom_hours.map(item => item.hours_perf)
                },
                {
                  name: "Administración Académica",
                  data: this.data_prom_hours.map(item => item.hours_admin)
                },
                {
                  name: "Extensión",
                  data: this.data_prom_hours.map(item => item.hours_extencion)
                },
                {
                  name: "Educación Continua",
                  data: this.data_prom_hours.map(item => parseFloat(item.hours_educ) || 0)
                }

              ])

              //this.series_academic_hours[0].data = this.academic_average_hours.map((item) => item[item.length - 1])
              //console.log(name_academics)
            }

            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
            this.$buefy.dialog.alert({
              title: "Error",
              message: "Error al obtener los datos.",
              confirmText: "OK",
              type: "is-danger",
            });
          })
    },

    downloadData(url) {
      this.isLoading = true;
      axios
          .get(url, { responseType: "blob" })
          .then((response) => {
            this.isLoading = false;
            const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            // Intenta recuperar el nombre del archivo desde el header
            let fileName = "archivo.xlsx";
            const disposition = response.headers["content-disposition"];
            if (disposition && disposition.includes("filename=")) {
              const match = disposition.match(
                  /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
              );
              if (match && match[1]) {
                fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
              }
            }

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
            this.$buefy.dialog.alert({
              title: "Error",
              message: "Error al descargar los datos.",
              confirmText: "OK",
              type: "is-danger",
            });
          });
    },

    openModalPromHours() {
      this.showModalPromHours = true;
    },
    closeModalPromHours() {
      this.showModalPromHours = false;
    },

    aplicarFiltro(estado) {
      // Si ya está activo este filtro, lo desactivamos
      if (this.filtroActivo === estado) {
        this.filtroActivo = null;

        // Restaurar los datos originales sin filtro
        this.$refs.apexChartComponent.updateSeries([
          {
            name: "Horas Promedio",
            data: this.prom_total_eq_sem
          }
        ]);
      } else {
        // Activar el filtro
        this.filtroActivo = estado;

        // Obtener datos filtrados y actualizar el gráfico
        const datosFiltrados = this.filtrarPromedioPorEstado(estado);
        this.$refs.apexChartComponent.updateSeries([
          {
            name: "Horas Promedio",
            data: datosFiltrados
          }
        ]);
      }
    },


    filtrarPromedioPorEstado(estado) {
      // Verificar si hay datos disponibles
      if (!this.data_prom_hours || !this.data_prom_hours.length ) {
        return null;
      }

      // Filtrar los académicos que tienen el estado especificado
      const academicosEnEstado = this.data_prom_hours.filter(item =>
          item.state_name.toLowerCase() === estado.toLowerCase()
      );

      // Obtener los nombres de los académicos en ese estado
      const nombresAcademicos = academicosEnEstado.map(item => item.academic_name);

      // Filtrar data_prom_hours para obtener solo los registros de los académicos en ese estado
      const datosFiltrados = this.data_prom_hours.filter(item =>
          nombresAcademicos.includes(item.academic_name)
      );

      // Si no hay datos filtrados, retornar null
      if (!datosFiltrados.length) {
        return [
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ];
      }

      // Calcular promedios por área
      const promedio = {
        docencia: 0,
        investigacion: 0,
        asistencia: 0,
        perfeccionamiento: 0,
        administracion: 0,
        extension: 0,
        educacion: 0,
      };

      // Sumar todas las horas por área
      datosFiltrados.forEach(item => {
        promedio.docencia += parseFloat(item.hours_docencia) || 0;
        promedio.investigacion += parseFloat(item.hours_inv_y_des) || 0;
        promedio.asistencia += parseFloat(item.hours_asi_tec) || 0;
        promedio.perfeccionamiento += parseFloat(item.hours_perf) || 0;
        promedio.administracion += parseFloat(item.hours_admin) || 0;
        promedio.extension += parseFloat(item.hours_extencion) || 0;
        promedio.educacion += parseFloat(item.hours_educ) || 0;
      });

      // Calcular el promedio dividiendo por el número de académicos
      const numAcademicos = datosFiltrados.length;
      Object.keys(promedio).forEach(key => {
        promedio[key] = +(promedio[key] / numAcademicos).toFixed(2);
      });

      return [
        promedio.docencia,
        promedio.investigacion,
        promedio.asistencia,
        promedio.perfeccionamiento,
        promedio.administracion,
        promedio.extension,
        promedio.educacion
      ]
    }


  },
}

</script>

<style scoped>
.card-stretch {
  height: 100%; /* Hace que la tarjeta ocupe todo el espacio de la columna */
  display: flex; /* Asegura que utilice flexbox */
  flex-direction: column; /* Mantén la disposición de los elementos en columna */
}

.columns {
  width: 100%; /* Asegura que las columnas mantengan sus proporciones */
}

.card-content {
  flex: 1; /* Ajusta la altura del contenido de las tarjetas sin alterar su ancho */
}

.card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card.is-selected {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  border: 3px solid #3273dc; /* Color primario de Bulma */
}




</style>